import { PageLayout } from '@ipfabric/ui-components/PageLayout/PageLayout';
import { UserProfile } from 'pages/Me/UserProfile/UserProfile';
import type { FC } from 'react';

export const UserProfilePage: FC = () => {
  return (
    <PageLayout>
      <UserProfile />
    </PageLayout>
  );
};
